module.exports = __webpack_public_path__ + "files/996c2c9b7f3d10dab32205229870b220.png";